/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Badge } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

interface NotificationBadgeProps {
    notifications: any[];
    children?: React.ReactNode;
    type: "messages" | "notifications" | "chat";
}

const NotificationBadge: React.FC<NotificationBadgeProps> = ({
    notifications,
    children,
    type,
}) => {
    const isMobile = useMediaQuery("(max-width: 768px)");
    const [badgeContent, setBadgeContent] = useState<number | string | null>(
        null
    );
    const [showBadge, setShowBadge] = useState(false);

    const calculateBadgeContent = () => {
        if (
            (type === "messages" || type === "chat") &&
            notifications.length > 0
        ) {
            // Get all unread notifications
            const allUnreadNotifications = notifications.filter(
                (notification) => notification.is_unread
            );

            // Get unread notifications that are mentions
            const unreadMentionedNotifications = allUnreadNotifications.filter(
                (notification) => notification.is_mentioned
            );

            // If there are no unread notifications at all, hide badge
            if (allUnreadNotifications.length === 0) {
                setBadgeContent(null);
                setShowBadge(false);
                return;
            }

            // If there are unread mentions, show the count
            if (unreadMentionedNotifications.length > 0) {
                setBadgeContent(unreadMentionedNotifications.length);
                setShowBadge(true);
                return;
            }

            // If there are unread non-mentioned notifications, show white dot (using special marker)
            setBadgeContent("•");
            setShowBadge(true);
        } else {
            // For other types, show count if there are notifications
            if (notifications.length > 0) {
                setBadgeContent(notifications.length);
                setShowBadge(true);
            } else {
                setBadgeContent(null);
                setShowBadge(false);
            }
        }
    };

    useEffect(() => {
        calculateBadgeContent();
    }, [notifications, type]);

    // Don't render badge if we shouldn't show it
    if (!showBadge) {
        return <>{children}</>;
    }

    // Check if we're showing a white dot (when content is "•")
    const isWhiteDot = badgeContent === "•";

    return (
        <Badge
            badgeContent={badgeContent}
            variant="standard"
            color="error"
            sx={{
                "& .MuiBadge-badge": {
                    backgroundColor: "#ff3838",
                    top: type === "chat" ? 7 : isMobile ? 3 : 21,
                    right: type === "chat" ? 6 : isMobile ? 0 : 36,
                    fontSize: isWhiteDot ? "12px" : "10px",
                    fontWeight: "bold",
                    minWidth: "15px",
                    height: "16px",
                    borderRadius: "50%",
                    color: isWhiteDot ? "white" : "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                },
            }}
        >
            {children}
        </Badge>
    );
};

export default NotificationBadge;
